import {createReducer} from '@reduxjs/toolkit';

import {setAreaCoverage} from '../actions/area-coverage.js';

export const initialState = [0, 1];

const areaCoverage = createReducer(initialState, builder => {
  builder.addCase(setAreaCoverage, (state, {payload}) =>
    payload.map(num => Math.round(num * 100) / 100)
  );
});

export default areaCoverage;
